<template>
  <FormPage :title="pageTitle" :description="pageDescription">
    <template #controls>
      <button class="btn" type="button" @click="goToHub">
        <font-awesome-icon icon="arrow-left" /> Назад к исполнителю
      </button>
    </template>

    <CompanyForm v-if="step === 'company'" @sendForm="sendForm" @closeForm="goToHub" />
    <ManagerForm
      v-else-if="step === 'manager'"
      :companyId="wizard.selectItems.companies && wizard.selectItems.companies.id"
      @sendForm="sendForm"
      @closeForm="goToHub"
    />
    <DriverForm v-else-if="step === 'driver'" @sendForm="sendForm" @closeForm="goToHub" />
    <CarForm
      v-else-if="step === 'car'"
      :company="wizard.selectItems.companies"
      @sendForm="sendForm"
      @closeForm="goToHub"
    />
    <TrailerForm v-else-if="step === 'trailer'" @sendForm="sendForm" @closeForm="goToHub" />
    <div v-else class="unknown-step">Неизвестный шаг мастера: {{ step }}</div>
  </FormPage>
</template>

<script>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import CompanyForm from '@/components/forms/CompanyForm.vue'
import ManagerForm from '@/components/forms/ManagerForm.vue'
import DriverForm from '@/components/forms/DriverForm.vue'
import CarForm from '@/components/forms/CarForm.vue'
import TrailerForm from '@/components/forms/TrailerForm.vue'
import { useExecutorWizardStore } from '@/stores/executorWizard'
import { useWizardBackGuard } from '@/composables/useWizardBackGuard'
import { invalidateManagersCache } from '@/backend/entitySmartSearchApi'

const STEP_META = {
  company: { title: 'Новая компания', description: 'Шаг мастера исполнителя: создайте компанию.' },
  manager: { title: 'Новый менеджер', description: 'Шаг мастера исполнителя: создайте менеджера.' },
  driver: { title: 'Новый водитель', description: 'Шаг мастера исполнителя: создайте водителя.' },
  car: { title: 'Новая машина', description: 'Шаг мастера исполнителя: создайте автомобиль. Можно сразу привязать прицеп.' },
  trailer: { title: 'Новый прицеп', description: 'Шаг мастера исполнителя: создайте прицеп.' },
}

export default {
  name: 'ExecutorWizardStep',
  components: { CompanyForm, ManagerForm, DriverForm, CarForm, TrailerForm },
  props: {
    step: { type: String, required: true },
  },
  setup(props) {
    const store = useStore()
    const router = useRouter()
    const wizard = useExecutorWizardStore()

    useWizardBackGuard({ name: 'ExecutorWizardHub' })

    const pageTitle = computed(() => STEP_META[props.step]?.title || 'Новый исполнитель')
    const pageDescription = computed(() => STEP_META[props.step]?.description || '')

    function goToHub() {
      router.push({ name: 'ExecutorWizardHub' })
    }

    async function sendForm(data) {
      const response = await store.dispatch('apiStorage/addItem', data)
      if (!response) return

      if (data.model === 'managers') {
        invalidateManagersCache()
      }

      if (response.car && response.trailer) {
        wizard.setItem('trailers', response.trailer)
        wizard.setItem('cars', response.car)
      } else if (response.car) {
        wizard.setItem('cars', response.car)
      } else if (response.trailer) {
        wizard.setItem('trailers', response.trailer)
      } else {
        wizard.setItem(data.model, response)
      }
      goToHub()
    }

    return {
      wizard,
      pageTitle,
      pageDescription,
      sendForm,
      goToHub,
    }
  },
}
</script>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid #d7dce2;
  border-radius: 8px;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  font-size: 13px;
}

.btn:hover {
  border-color: #2563eb;
  color: #2563eb;
}

.unknown-step {
  padding: 32px;
  text-align: center;
  color: #dc3545;
}
</style>
